import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import { IProdutoLimitacaoConsumoDetails, IProdutoTipoConsumoLimitacaoConsumoAtivo } from "../../application/models"

export const useProdutoLimitacaoConsumoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const produtoLimitacaoConsumoGetAllAtivosApi = useCallback(async (): Promise<IProdutoLimitacaoConsumoDetails[]> => {
        try {
            const result = await axiosAuthInstance.get('/produto-limitacao-consumo')

            return result.data.produtoLimitacaoConsumoList
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const produtoLimitacaoConsumoGetTipoConsumoAtivosApi = useCallback(async (IdProduto: number): Promise<IProdutoTipoConsumoLimitacaoConsumoAtivo[]> => {
        try {
            const result = await axiosAuthInstance.get(
                `/produto-limitacao-consumo/tipo-consumo-ativos/${encodeURIComponent(String(IdProduto))}`
            )

            return result.data.produtoTipoConsumoLimitacaoConsumoList ?? []
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        produtoLimitacaoConsumoGetAllAtivosApi,
        produtoLimitacaoConsumoGetTipoConsumoAtivosApi
    }
}